import { InjectionToken } from '@angular/core';
import { BrandsAssets, RetailBrands } from './constants';

export const RETAIL_BRAND_NAME = new InjectionToken<RetailBrands>('RETAIL_BRAND_NAME');

export const RETAIL_BRAND_ASSET = new InjectionToken<BrandsAssets>('RETAIL_BRAND_ASSET');
